import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import { ToastContainer, toast } from "react-toastify";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./listofUsers.css";
import Header from "../../../COMPONENTS/header/Header";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";

function ListofUsers() {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const createdDate = new Date();
  const formattedDate = createdDate.toISOString();

  useEffect(() => {
    axios
      .get("/api/users", {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((response) => {
        const dataResponse = response.data.map((certificates, index) => ({
          ...certificates,
          rowNumber: index + 1,
        }));
        setUsers(dataResponse);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [accessToken]);

  const handlePendingApprove = (id, username) => {
    if (auth.username === username) {
      alert("You cant approve the user you have added!");
    } else {
      axios
        .post(
          "/api/approve-user",
          { id, approvedBy: auth.username, approvedDate: formattedDate },
          {
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        )
        .then((response) => {
          toast.success("User approved successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleResetPassword = (id) => {
    const resetPassword = {
      id,
    };
    navigate("/resetPassword", { state: { resetPassword } });
  };

  const handleView = (
    firstName,
    middleName,
    lastName,
    username,
    email,
    subscriberName,
    digitalLendor,
    phoneNumber,
    isDisputeManagement,
    isNameLookup,
    isPressureLetter,
    id
  ) => {
    const userDetails = {
      firstName,
      middleName,
      lastName,
      username,
      email,
      subscriberName,
      digitalLendor,
      phoneNumber,
      isDisputeManagement,
      isNameLookup,
      isPressureLetter,
      id,
    };
    navigate("/userDetails", { state: { userDetails } });
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.1,
    },
    {
      field: "first_name",
      headerName: "First Name",
      flex: 0.3,
    },
    {
      field: "middle_name",
      headerName: "Middle Name",
      flex: 0.3,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      flex: 0.3,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 0.3,
    },
    {
      field: "subscriber_name",
      headerName: "Subscriber Name",
      flex: 0.7,
    },
    {
      field: "added_by",
      headerName: "Added By",
      flex: 0.3,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.7,
      renderCell: (params) => {
        return (
          <>
            {params.row.status === "Pending" ? (
              <button
                className="approveUserButton"
                onClick={() =>
                  handlePendingApprove(params.row.id, params.row.added_by)
                }
              >
                Approve User
              </button>
            ) : (
              <>
                <button
                  className="resetUserButton"
                  onClick={() => handleResetPassword(params.row.id)}
                >
                  Change Password
                </button>
                <button
                  className="updateUserButton"
                  onClick={() =>
                    handleView(
                      params.row.first_name,
                      params.row.middle_name,
                      params.row.last_name,
                      params.row.username,
                      params.row.email,
                      params.row.subscriber_name,
                      params.row.digital_lendor,
                      params.row.phone_number,
                      params.row.isdispute_management,
                      params.row.isname_lookup,
                      params.row.ispressure_letter,
                      params.row.id
                    )
                  }
                >
                  Update User
                </button>
              </>
            )}
          </>
        );
      },
    },
  ];
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="10px">
          <Box m="10px">
            <Header title="USERS" subtitle="View all users in the system" />
            <Box
              m="40px 0 0 0"
              height="100vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#a4a9fc",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={users}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </Box>
      </main>
      <ToastContainer />
    </div>
  );
}

export default ListofUsers;
